/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-named-as-default-member */

import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import ExcelJS, { Row } from 'exceljs'

import { FAMILY_TSHIRT_SIZES } from '../../../../constants/models'

import {
  addRow,
  dataStyle,
  dateSort,
  FormEvent,
  FormParticipant,
  headerStyle,
  ItemCount,
  prioritySort,
  SpreadsheetInput,
  summaryFooterStyle,
  summaryHeaderStyle,
  summaryStyle,
} from '.'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
dayjs.extend(isSameOrBefore)

export const workbook = (
  event: FormEvent,
  data: SpreadsheetInput,
  formShirtData: any,
) => {
  let sheet: ExcelJS.Worksheet
  const workbook = new ExcelJS.Workbook()

  const tshirtCountArr = Object.keys(FAMILY_TSHIRT_SIZES).reduce(
    (prev, cur, index) => {
      return {
        ...prev,
        [cur]: {
          count: 0,
          name: cur,
          priority: index + 1,
        },
      }
    },
    {},
  )
  const categoryCountArr = []

  let totalCount = 0

  Object.keys(formShirtData).forEach((shirtData, index) => {
    const names = shirtData.split('_')
    if (Number(formShirtData[shirtData])) {
      if (!Object.keys(tshirtCountArr).includes(names[0])) {
        tshirtCountArr[names[0]] = {
          count: 0,
          name: names[0],
          priority: Object.keys(tshirtCountArr).length + 1,
        }
      }
      if (!Object.keys(categoryCountArr).includes(names[1])) {
        categoryCountArr[names[1]] = {
          count: 0,
          name: names[1],
          priority: index,
        }
      }

      tshirtCountArr[names[0]].count += formShirtData[shirtData]
      categoryCountArr[names[1]].count += formShirtData[shirtData]
      totalCount += formShirtData[shirtData]
    }
  })

  // add summary sheet first, add data later
  workbook.addWorksheet('Summary')

  const generateParticipants = () => {
    sheet = workbook.addWorksheet('Registrations')
    sheet.columns = [
      { header: 'createdAt', key: 'createdAt', width: 25 },
      { header: 'id', key: 'participantId', width: 10 },
      { header: 'firstName', key: 'firstName', width: 25 },
      { header: 'lastName', key: 'lastName', width: 25 },
      { header: 'status', key: 'status', width: 10 },
      { header: 'fee', key: 'fee', width: 5 },
      { header: 'paymentMode', key: 'paymentMode', width: 15 },
      { header: 'tshirtCount', key: 'tshirtCount', width: 10 },
      { header: 'tshirtCountSummary', key: 'tshirtCountSummary' },
    ]
    sheet.getRow(1).font = headerStyle.font
    sheet.getRow(1).fill = headerStyle.fill
    ;(data[event.id] as FormParticipant[])
      .sort(dateSort)
      .forEach((item: FormParticipant) => {
        const newRow = sheet.addRow({
          ...item,
          tshirtCountSummary: item.tshirtCount,
          tshirtCount: item.tshirtCountTotal,
        }) as Row
        newRow.font = dataStyle.font
      })
  }

  const generateSummary = () => {
    sheet = workbook.getWorksheet('Summary')
    sheet.getColumn(1).width = 3
    sheet.getColumn(2).width = 25

    // TSHIRT COUNT
    sheet.addRow([])
    sheet = addRow({
      sheet,
      data: ['', 'TSHIRT SIZE COUNT', ''],
      style: summaryHeaderStyle,
      exclude: [1],
    })

    Object.values(tshirtCountArr)
      .sort(prioritySort)
      .forEach((item: ItemCount) => {
        sheet = addRow({
          sheet,
          data: ['', item.name, item.count],
          style: summaryStyle,
          exclude: [1],
        })
      })

    sheet = addRow({
      sheet,
      data: ['', 'Total', totalCount],
      style: summaryFooterStyle,
      exclude: [1],
    })

    // CATEGORY COUNT
    sheet.addRow([])
    sheet = addRow({
      sheet,
      data: ['', 'PARTICIPANT COUNT', ''],
      style: summaryHeaderStyle,
      exclude: [1],
    })

    Object.values(categoryCountArr)
      .sort(prioritySort)
      .forEach((item: ItemCount) => {
        sheet = addRow({
          sheet,
          data: ['', item.name, item.count],
          style: summaryStyle,
          exclude: [1],
        })
      })
    sheet = addRow({
      sheet,
      data: ['', 'Total', totalCount],
      style: summaryFooterStyle,
      exclude: [1],
    })
  }

  generateParticipants()
  generateSummary()
  return workbook
}
